<template>
	<div class="user-info">
		<div v-if="wwUserInfo == 'load'" class="loading-animation"><div class="box"><span></span></div></div>
		<p v-else-if="wwUserInfo == {}" class="shift">没有相关数据！</p>
		<dl v-else>
			<dd>
				<label>所在地：</label>{{ wwUserInfo.location }}
			</dd>
			<dd>
				<label>发出好评率：</label>{{ wwUserInfo.sendgood }}
			</dd>
			<dd>
				<label>收到好评率：</label>{{ wwUserInfo.getgood }}
			</dd>
			<dd>
				<label>上次登录：</label>{{ wwUserInfo.last }}
			</dd>
			<dd>
				<label>注册时间：</label>{{ wwUserInfo.created }}
			</dd>
			<dd>
				<label>认证：</label>{{ wwUserInfo.auth }}
			</dd>
			<dd>
				<label>最近交易：</label>{{ wwUserInfo.tradelastt }}
			</dd>
			<dd>
				<label>成交笔、件宝贝合计：</label>￥{{ wwUserInfo.tradetotal }}
			</dd>
			<dd>
				<label>交易被关闭笔数：</label>{{ wwUserInfo.tradeclose }}
			</dd>
		</dl>
	</div>
</template>

<script>
export default {
	name: 'wwUserInfoTpl',
	data () {
		return {}
	},
	computed: {
		wwUserInfo () {
			return this.$store.state.wwUserInfo;
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/aside/wwUserInfo.vue